import styled from 'styled-components';
import Slider from 'react-rangeslider';

export const StyledSlider = styled(Slider)`
  .rangeslider__fill {
    background-color: ${(props) => (props.disabled ? '#BCC2E0' : '#556EE6')} !important;
  }
`;
